module.exports = {
      id: "angle-left-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#angle-left",
      toString: function () {
        return this.url;
      }
    }